module.exports = __webpack_public_path__ + "public/adminIcons/reportManage.svg?da521a29";